import Layout from "components/Layout";
import React from "react";
import ItemSettingTable from "./components/ItemSettingTable";

function ItemSetting() {
  return (
    <Layout title="알람 항목 관리">
      <ItemSettingTable />
    </Layout>
  );
}

export default ItemSetting;
